"use client";

import { useImperativeHandle, useRef, useState, type Ref, type ReactNode } from "react";
import { ScrollConsent, type PrivacyConsentHandle } from "./PrivacyConsent";
import { DocumentBody } from "./DocumentBody";
import documents from "./registration-documents.json";

export function RegistrationInformationNotice() {
  return <p className="mt-4 text-center text-xs leading-6 text-[var(--color-muted)]">本页面收集的账号信息用于注册、登录及账号服务</p>;
}

export function RegistrationConsent({ onChange, ref, children }: { children?: ReactNode; agreed: boolean; onChange: (value: boolean) => void; ref?: Ref<PrivacyConsentHandle> }) {
  const [accepted, setAccepted] = useState([false, false]);
  const acceptedRef = useRef([false, false]);
  const first = useRef<PrivacyConsentHandle>(null);
  const second = useRef<PrivacyConsentHandle>(null);
  function change(index: number, value: boolean) {
    const next = [...acceptedRef.current];
    next[index] = value;
    acceptedRef.current = next;
    setAccepted(next);
    onChange(next.every(Boolean));
  }
  useImperativeHandle(ref, () => ({ requestConsent(onAccepted) {
    const finish = () => {
      if (acceptedRef.current[1]) onAccepted();
      else second.current?.requestConsent(onAccepted);
    };
    if (acceptedRef.current[0]) finish();
    else first.current?.requestConsent(finish);
  } }), []);
  return <div className="rg-registration-consents grid gap-2">
    {documents.map((document, index) => <ScrollConsent key={document.id} ref={index === 0 ? first : second}
      compact confirmationText="我已阅读并同意" agreed={accepted[index]} onChange={value => change(index, value)} title={document.title}>
      <DocumentBody blocks={document.blocks} />
    </ScrollConsent>)}
    {children}
  </div>;
}

// Preview choices stay in memory and never write a registration consent receipt.
export function RegistrationConsentPreview({ children }: { children?: ReactNode }) {
  const [agreed, setAgreed] = useState(false);
  return <RegistrationConsent agreed={agreed} onChange={setAgreed}>{children}</RegistrationConsent>;
}
